// @mui material components
import Card from "@mui/material/Card";
import React from "react";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import LockIcon from "@mui/icons-material/Lock";
import { VscEye, VscEyeClosed } from "react-icons/vsc";

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Link, useNavigate } from "react-router-dom";
import headerBg from "assets/images/curved-images/Header.png";
import { toast } from "react-toastify";
import api from "store/api/api";
import { List, ListItem } from "@mui/material";

function TermsandConditions() {
  
  return (
    <SoftBox>
      <SoftBox p={3}>
        <SoftTypography variant="body1">
          <strong>Effective Date:</strong>
          <span style={{ fontWeight: 400 }}> April, 2025</span>
        </SoftTypography>

        <SoftTypography paragraph>
          These Terms and Conditions (“Terms”) govern your access to and use of
          the CC&I Field Reporting mobile application (“App”) and related
          services provided by <strong>G2 Web Development LLC</strong> (“we,”
          “us,” or “our”).
        </SoftTypography>

        <SoftTypography paragraph>
          By accessing or using the App, you agree to be bound by these Terms.
        </SoftTypography>

        <SoftTypography variant="subtitle1" fontWeight="bold" gutterBottom>
          1. Use of the App
        </SoftTypography>
        <SoftTypography paragraph>
          The CC&I Field Reporting App is intended for authorized users within
          companies using the App for internal field inspection and reporting
          purposes. You agree to use the App only for lawful purposes and in
          accordance with these Terms.
        </SoftTypography>

        <SoftTypography variant="subtitle1" fontWeight="bold" gutterBottom>
          2. User Accounts
        </SoftTypography>
        <SoftTypography paragraph>
          Access to certain features may require creating a user account. You
          are responsible for maintaining the confidentiality of your account
          information and for all activities under your account.
        </SoftTypography>

        <SoftTypography variant="subtitle1" fontWeight="bold" gutterBottom>
          3. Data and Content
        </SoftTypography>
        <SoftTypography paragraph>
          You are responsible for any content you input into the App, including
          inspection data, images, and project information. We are not
          responsible for the accuracy, completeness, or legality of content
          entered by users.
        </SoftTypography>

        <SoftTypography variant="subtitle1" fontWeight="bold" gutterBottom>
          4. Offline Use and Data Syncing
        </SoftTypography>
        <SoftTypography paragraph>
          The App allows offline data entry. Data is synced when an internet
          connection is available. You are responsible for ensuring your device
          properly syncs and that all critical data is uploaded successfully.
        </SoftTypography>

        <SoftTypography variant="subtitle1" fontWeight="bold" gutterBottom>
          5. Intellectual Property
        </SoftTypography>
        <SoftTypography paragraph>
          The CC&I Field Reporting App, including its specific design, features,
          and source code, is owned by CC&I upon completion and delivery of the
          project, subject to the terms of the agreement between CC&I and G2 Web
          Development LLC. G2 Web Development LLC retains ownership of any
          general frameworks, libraries, or reusable components developed
          independently of the CC&I-specific implementation. Users may not copy,
          modify, distribute, or create derivative works from the CC&I Field
          Reporting App without the express written consent of CC&I.
        </SoftTypography>

        <SoftTypography variant="subtitle1" fontWeight="bold" gutterBottom>
          6. Disclaimer of Warranties
        </SoftTypography>
        <SoftTypography paragraph>
          The App is provided “as is” without warranties of any kind, express or
          implied. We do not guarantee that the App will be error-free,
          uninterrupted, or fully secure.
        </SoftTypography>

        <SoftTypography variant="subtitle1" fontWeight="bold" gutterBottom>
          7. Limitation of Liability
        </SoftTypography>
        <SoftTypography paragraph>
          To the maximum extent permitted by law, G2 Web Development LLC shall
          not be liable for any indirect, incidental, special, or consequential
          damages arising out of your use of or inability to use the App.
        </SoftTypography>

        <SoftTypography variant="subtitle1" fontWeight="bold" gutterBottom>
          8. Updates and Modifications
        </SoftTypography>
        <SoftTypography paragraph>
          We may update or modify the App and these Terms at any time. Continued
          use of the App after changes are posted constitutes your acceptance of
          the updated Terms.
        </SoftTypography>

        <SoftTypography variant="subtitle1" fontWeight="bold" gutterBottom>
          9. Termination
        </SoftTypography>
        <SoftTypography paragraph>
          We reserve the right to suspend or terminate access to the App for
          violations of these Terms or for any other reason at our sole
          discretion.
        </SoftTypography>

        <SoftTypography variant="subtitle1" fontWeight="bold" gutterBottom>
          10. Contact Information
        </SoftTypography>
        <SoftTypography paragraph>
          G2 Web Development LLC
          <br />
          Email:{" "}
          <Link href="mailto:info@g2webdevelopment.com">
            info@g2webdevelopment.com
          </Link>
          <br />
          Phone: +1 (864) 561-5380
          <br />
          Website:{" "}
          <Link
            href="https://g2webdevelopment.com"
            target="_blank"
            rel="noopener"
          >
            https://g2webdevelopment.com
          </Link>
        </SoftTypography>

        <SoftTypography variant="body2" color="textSecondary" mt={4}>
          © 2025 G2 Web Development LLC. All rights reserved.
        </SoftTypography>
      </SoftBox>
    </SoftBox>
  );
}

export default TermsandConditions;
